export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تذكير بالإغلاق"])}
        }
      },
      "ar-EG": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تذكير بالإغلاق"])}
        }
      },
      "ar-SA": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تذكير بالإغلاق"])}
        }
      },
      "el-GR": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κλείσιμο υπενθύμισης"])}
        }
      },
      "el-CY": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κλείσιμο υπενθύμισης"])}
        }
      },
      "de-DE": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erinnerung schließen"])}
        }
      },
      "de-AT": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erinnerung schließen"])}
        }
      },
      "de-CH": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erinnerung schließen"])}
        }
      },
      "en-US": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Close reminder"])}
        }
      },
      "en-GB": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Close reminder"])}
        }
      },
      "it-IT": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promemoria di chiusura"])}
        }
      },
      "fr-FR": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fermer le rappel"])}
        }
      },
      "es-ES": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cerrar recordatorio"])}
        }
      },
      "pl-PL": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zamknij przypomnienie"])}
        }
      },
      "nl-NL": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Herinnering sluiten"])}
        }
      },
      "bg-BG": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Затваряне на напомняне"])}
        }
      },
      "bs-BA": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zatvori podsjetnik"])}
        }
      },
      "da-DK": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Luk påmindelse"])}
        }
      },
      "et-EE": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sule meeldetuletus"])}
        }
      },
      "fi-FI": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sulje muistutus"])}
        }
      },
      "he-IL": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["תזכורת קרובה"])}
        }
      },
      "ga-IE": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dún meabhrúchán"])}
        }
      },
      "ja-JP": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["リマインダーを閉じる"])}
        }
      },
      "hr-HR": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zatvori podsjetnik"])}
        }
      },
      "lv-LV": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aizvērt atgādinājumu"])}
        }
      },
      "lt-LT": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uždaryti priminimą"])}
        }
      },
      "pt-PT": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fechar lembrete"])}
        }
      },
      "ro-RO": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Închideți mementoul"])}
        }
      },
      "ru-RU": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Закрыть напоминание"])}
        }
      },
      "sv-SE": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stäng påminnelse"])}
        }
      },
      "sk-SK": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zavrieť pripomenutie"])}
        }
      },
      "cs-CZ": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zavřít připomenutí"])}
        }
      },
      "hu-HU": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Emlékeztető bezárása"])}
        }
      },
      "fr-BE": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fermer le rappel"])}
        }
      },
      "fr-LU": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fermer le rappel"])}
        }
      },
      "mt-MT": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agħlaq it-tfakkira"])}
        }
      },
      "sl-SI": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zapri opomnik"])}
        }
      },
      "tr-TR": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hatırlatıcıyı kapat"])}
        }
      },
      "tr-CY": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hatırlatıcıyı kapat"])}
        }
      },
      "uk-UA": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Закрити нагадування"])}
        }
      },
      "zh-CN": {
        "close": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["关闭提醒"])}
        }
      }
    }
  })
}
